import { all, fork } from 'redux-saga/effects';
import { watchGetProjectByIdSaga, watchUpdateProjectPhaseDatesSaga, watchAddMemberToProjectSaga, watchRemoveMemberFromProjectSaga, watchUpdateProjectMembersSaga, watchCreateAndInviteProjectMembers, watchProjectTimelineSaga, watchDateShiftSaga } from './sagas';
function* projectRootSaga() {
    yield all([
        fork(watchGetProjectByIdSaga),
        fork(watchUpdateProjectPhaseDatesSaga),
        fork(watchAddMemberToProjectSaga),
        fork(watchRemoveMemberFromProjectSaga),
        fork(watchUpdateProjectMembersSaga),
        fork(watchCreateAndInviteProjectMembers),
        fork(watchProjectTimelineSaga),
        fork(watchDateShiftSaga)
    ]);
}
export { projectRootSaga };
export * from './hooks';
